import { render, staticRenderFns } from "./ManagementTable.vue?vue&type=template&id=1d2dabd4&"
import script from "./ManagementTable.vue?vue&type=script&lang=js&"
export * from "./ManagementTable.vue?vue&type=script&lang=js&"
import style0 from "./ManagementTable.vue?vue&type=style&index=0&id=1d2dabd4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports